/**
 * Framework dev-mode detection.
 *
 * Iterates drupalSettings keys that look like an SDX framework
 * namespace and returns true when any of them declare a Vite dev
 * server URL. The iteration is key-pattern-based rather than hard
 * coded so new framework modules (sdx_react, sdx_vue, sdx_svelte,
 * sdx_solid, ...) are picked up automatically without any change
 * to this file - an OCP-friendly extension point.
 */

export function isAnyFrameworkInDevMode(settings: DrupalSettings): boolean {
  for (const key of Object.keys(settings)) {
    if (!isFrameworkNamespaceKey(key)) {
      continue;
    }
    const namespace = settings[key];
    if (!namespace || typeof namespace !== 'object') {
      continue;
    }
    const devServer = (namespace as { dev_server?: unknown }).dev_server;
    if (typeof devServer === 'string' && devServer.length > 0) {
      return true;
    }
  }
  return false;
}

/**
 * Framework namespaces follow the `sdx_<framework>` convention.
 *
 * `sdx` itself (the core SDX settings namespace) is intentionally
 * excluded because it is not a framework. `sdxEditSession` is also
 * excluded because it starts with `sdx` but lacks the underscore
 * separator that marks a framework namespace.
 */
function isFrameworkNamespaceKey(key: string): boolean {
  return /^sdx_[a-z0-9]/.test(key);
}
